import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../components/PageHeader';
import ImageUpload from '../components/ImageUpload';
import Footer from 'components/PageFooter';

const ImageUploadPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      <PageHeader />
      <div className="flex-1 w-full max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">{t('pages.imageUploadTitle')}</h2>
          <p className="text-gray-600 dark:text-gray-400">{t('pages.imageUploadSubtitle')}</p>
        </div>

        <ImageUpload />
      </div>
      <Footer />
    </div>
  );
};

export default ImageUploadPage;
